import {Component, EventEmitter, inject, Input, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormPopupComponent} from "../../../../components";
import {ShiftFormComponent} from "../shift-form/shift-form.component";
import {GetShiftQuery, ShiftDto, ShiftsClient, UpdateShiftCommand} from "@services";
import notify from "devextreme/ui/notify";

@Component({
    selector: 'edit-shift-form',
    imports: [
        FormPopupComponent,
        ShiftFormComponent
    ],
    templateUrl: './edit-shift-form.component.html'
})
export class EditShiftFormComponent {
    @ViewChild(ShiftFormComponent, {static: false}) editNewForm: ShiftFormComponent;

    private shiftsClient = inject(ShiftsClient);

    @Input() shiftId: string;
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() onSave = new EventEmitter();

    formData: ShiftDto = {} as ShiftDto;

    loadShiftById = (id: any) => {
        const command = new GetShiftQuery({shiftId: id});
        this.shiftsClient.getShift(command).subscribe({
            next: (data: ShiftDto) => {
                this.formData = data;
            },
            error: () => {
            }
        });
    };

    onPopupSaveClick = () => {
        let formData = this.editNewForm.getData();

        let createCommand = new UpdateShiftCommand({
            shiftId: this.shiftId,
            shiftType: formData.shiftType,
            shiftStart: formData.shiftStart,
            shiftEnd: formData.shiftEnd,
            code: formData.code,
            days: formData.days,
            supervisorId: formData.supervisorId,
            locked: formData.locked,
            showInHuddle: formData.showInHuddle,
            hasMealTicked: formData.hasMealTicked,
            premiumRate: formData.premiumRate,
            mealTickedRoles: formData.mealTickedRoles
        })

        this.shiftsClient.updateShift(createCommand).subscribe({
            next: async () => {
                this.visible = false;
                this.visibleChange.emit(this.visible);
                this.onSave.emit();
            },
            error: (errors: Array<any>) => {
                errors.forEach((errMsg => {
                    notify({
                        message: errMsg.message,
                        type: "error",
                        displayTime: 5000,
                    }, {
                        position: "bottom right",
                        direction: "up-push"
                    });
                }));
            }
        });
    };

    onVisibleChange(visible: boolean) {
        this.visibleChange.emit(visible);
    }

    protected onOpen() {
        this.loadShiftById(this.shiftId);
    }
}
